<template>
    <transition name="modal">
        <b-modal ref="project-modal" id="start-project-modal" :body-class="screen" v-on:hide="hiding" :size="size" :hide-footer="screen === 'form-submitted'" no-close-on-esc no-close-on-backdrop>
            <div slot="modal-title" class="text-center">
                Start  A New Project
            </div>           
            
            <div v-if="screen === 'project-type'">
                <p>To get started, tell us about your project.</p>

                <b-form-group label="What's the voice over for?">
                    <multiselect 
                        v-model="application" 
                        :allowEmpty="false" 
                        :options="applications" 
                        label="name"
                        selectLabel=""
                        selectedLabel=""
                        deselectLabel=""
                        >
                    </multiselect>
                </b-form-group>
            </div>

            <div v-if="screen === 'form'">

                <b-container>
                    <b-row>
                        <b-col md="12">
                            <h2>Help Is On The Way!</h2>
                            <p>
                                This project looks especially important, so we're assigning it to a knowledgeable GM Voices team member to make sure we provide the best voice choices and pricing based on your unique details.<br />
                                Please fill out the form below and we'll get back to you ASAP (like, within minutes).
                            </p>
                        </b-col>
                        <b-col md="12">
                            <b-form-group label="Project Overview *" required>
                                <b-form-textarea v-model="form.projectOverview" :state="(typeof errors['projectOverview'] !== 'undefined') ? 'invalid': null" aria-describedby="input-live-feedback" />
                            </b-form-group>
                        </b-col>
                        <b-col md="12">
                            <b-form-group label="Intended Use? *" required :state="(typeof errors['application'] !== 'undefined') ? 'invalid' : null" :invalid-feedback="errors['application']">
                                <multiselect 
                                    v-model="application" 
                                    :allowEmpty="false" 
                                    :options="$store.getters['tag/applications']" 
                                    label="name"
                                    selectLabel=""
                                    selectedLabel=""
                                    deselectLabel=""
                                    >
                                </multiselect>
                            </b-form-group>
                            <b-form-invalid-feedback id="input-live-feedback">
                                {{errors['first_name']}}
                            </b-form-invalid-feedback>
                        </b-col>

                        <b-col md="6">
                            <b-form-group label="Gender">
                                <multiselect 
                                    v-model="form.gender" 
                                    :allowEmpty="false" 
                                    :options="genders" 
                                    selectLabel=""
                                    selectedLabel=""
                                    deselectLabel=""
                                    >
                                </multiselect>
                            </b-form-group>
                        </b-col>

                        <b-col md="6">
                            <b-form-group label="Voice Age">
                                <b-input type="text" v-model="form.voiceAge" />
                            </b-form-group>
                        </b-col>

                        <b-col md="6">
                            <b-form-group label="Language/Accent *" required>
                                <b-form-input type="text" v-model="form.languageAccent" :state="(typeof errors['languageAccent'] !== 'undefined') ? 'invalid': null" aria-describedby="input-live-feedback"></b-form-input>
                            </b-form-group>
                        </b-col>

                        <b-col md="6">
                            <b-form-group label="Translation Required?">
                                <b-checkbox v-model="form.translation" />
                            </b-form-group>
                        </b-col>

                        <b-col md="6">
                            <b-form-group label="Budget">   
                                <b-input type="text" v-model="form.budget" />
                            </b-form-group>
                        </b-col>

                        <b-col md="6">
                            <b-form-group label="Response Deadline">
                                <datepicker v-model="form.responseDeadline" format="yyyy-MM-dd"></datepicker>
                            </b-form-group>
                        </b-col>

                        <b-col md="6" offset-md="6">
                            <b-form-group label="Delivery Deadline">
                                <datepicker v-model="form.deliveryDeadline" format="yyyy-MM-dd"></datepicker>
                            </b-form-group>
                        </b-col>

                        <b-col md="12">
                            <b-form-group label="Script Estimated Length">
                                <b-textarea v-model="form.scriptLength" />
                            </b-form-group>
                        </b-col>

                        <b-col md="12">
                            <b-form-group label="Artistic Direction / Talent Notes">
                                <b-textarea v-model="form.talentNotes" />
                            </b-form-group>
                        </b-col>

                        <b-col md="12">
                            <b-form-group label="Additional Notes">
                                <b-textarea v-model="form.additionalNotes" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-container>

            </div>

            <div v-if="screen === 'form-submitted'">
                <h2>We Have Your Project Details!</h2>

                <h4>Application type? Check. Language? Check. Budget? Check.</h4>

                <p>Now that we have your information, a helpful GM Voices representative will be following up with you shortly to give you the best voice samples and most 
                    economical pricing for your voice-over project. Thanks for your interest!</p>
            </div>

            <div slot="modal-footer" v-if="screen !== 'form-submitted'">
                <b-button class="float-left" varient="secondary" @click="screen = 'project-type'" v-if="screen === 'form'">Back</b-button>
                <b-button type="submit" class="float-right" variant="primary" @click="submit">Submit</b-button>
            </div>
        </b-modal>
    </transition>
</template>

<script>      
    import Multiselect from 'vue-multiselect'
    import Datepicker from 'vuejs-datepicker';
    import {mapGetters} from 'vuex'
    export default {
        components: {Multiselect, Datepicker},
        data() {
            return {
                form: {
                    projectOverview: null,
                    application: null,
                    gender: null,
                    voiceAge: null,
                    languageAccent: null,
                    translation: null,
                    budget: 0,
                    responseDeadline: null,
                    deliveryDeadline: null,


                    scriptLength: null,
                    talentNotes: null,
                    additionalNotes: null
                },

                application: null,

                screen: 'project-type',

                error: null,
                errors: {}
            }
        },
        methods: {
            submit () {
                if (!this.application) {
                    this.error = 'Please tell us what the voice over is for'
                }

                this.$store.commit('project/setApplication', this.application)

                if (this.application && this.application.id === this.applications[0].id) {
                    this.$emit('ProjectModalClose', this.application)
                    return this.$refs['project-modal'].hide()
                }

                if (this.screen === 'form' && this.application) {
                    this.form.application = this.application.name
                    this.errors = {}
                    // Submit form
                    this.axios.post('/projects/new/form', this.form)
                        .then(res => {
                            this.screen = 'form-submitted'
                        })
                        .catch(err => {
                            this.error = 'There was an error creating the account'
                            for (var field in err.response.data.errors) {
                                this.$set(this.errors, field, err.response.data.errors[field][0])
                            }
                        })
                }

                if (this.application) {
                    this.screen = 'form'
                }
            },
            hiding () {
                if (!this.application ||
                    this.screen === 'form' || this.screen === 'form-submitted') {
                    this.$router.push({name: 'projects'})
                }
            }
        },
        computed: {
            ...mapGetters({
                applications: 'tag/applications'
            }),
            typeOptions () {
                return this.applications.map(type => {
                    return { text: type.name, value: type.id }
                })
            },
            genders () {
                return ['Male', 'Female']
            },
            size () {
                return (this.screen === 'form') ? 'lg' : null
            }
        },
        mounted () {
            if (this.$store.state.project.application) {
                this.application = this.$store.state.project.application
                
                this.$emit('ProjectModalClose', this.application)
                this.$bvModal.hide('start-project-modal')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// prompts/components/project/NewProjectModal.vue